import { supabase } from "../../supabase/supabase";
import { MicroPrompt, MicroPromptFormData } from "@/types/microPrompt";

export const microPromptService = {
  /**
   * Get all micro prompts for an organization
   */
  async getMicroPrompts(organizationId: string): Promise<MicroPrompt[]> {
    try {
      const { data, error } = await supabase
        .from("micro_prompts")
        .select("*")
        .eq("organization_id", organizationId)
        .order("title", { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error("Error fetching micro prompts:", error);
      return [];
    }
  },

  /**
   * Create a new micro prompt
   */
  async createMicroPrompt(
    organizationId: string,
    formData: MicroPromptFormData,
    userId: string,
  ): Promise<MicroPrompt | null> {
    try {
      const { data, error } = await supabase
        .from("micro_prompts")
        .insert([
          {
            organization_id: organizationId,
            title: formData.title,
            content: formData.content,
            created_by: userId,
          },
        ])
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error creating micro prompt:", error);
      throw error;
    }
  },

  /**
   * Update an existing micro prompt
   */
  async updateMicroPrompt(
    id: string,
    formData: MicroPromptFormData,
  ): Promise<MicroPrompt | null> {
    try {
      const { data, error } = await supabase
        .from("micro_prompts")
        .update({
          title: formData.title,
          content: formData.content,
          updated_at: new Date().toISOString(),
        })
        .eq("id", id)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error updating micro prompt:", error);
      throw error;
    }
  },

  /**
   * Delete a micro prompt
   */
  async deleteMicroPrompt(id: string): Promise<boolean> {
    try {
      const { error } = await supabase
        .from("micro_prompts")
        .delete()
        .eq("id", id);

      if (error) throw error;
      return true;
    } catch (error) {
      console.error("Error deleting micro prompt:", error);
      return false;
    }
  },
};
